<script>
	import { fade, draw, fly } from 'svelte/transition';
	import { AumeeAnalytics } from './utils/analytics';
    import { onDestroy, onMount } from 'svelte';
    import { addStats, extractSectionValue, handleScroll } from './utils/index';

	import axios from 'axios';
	import profile from '../public/profile';

	import ProfilePicture from './components/ProfilePicture.svelte';
	import Button from './components/Button.svelte';
	import CircleSVG from './components/CircleSVG.svelte';
	import ProfileInformations from './components/ProfileInformations.svelte';
	import Categories from './components/Categories.svelte';
	import CategorySummary from './components/CategorySummary.svelte';
	import CategoryDetail from './components/CategoryDetail.svelte';
    import { getCookie, setCookie } from './utils/cookies';
	

	let isLoading = true;
	let sessionId;
	let isDelayNeeded = true;
	let categoryToDisplay = null;

	AumeeAnalytics.init();
	AumeeAnalytics.setScrollElementId('main');
	AumeeAnalytics.addParameterToInsert('section', extractSectionValue);

	if(window.location.href.indexOf('/#/') < 0) {
        let splitKey = window.location.host;
        if(window.location.href.indexOf(splitKey + '/') > 0) {
            splitKey += '/';
        }
        const urlSplit = window.location.href.split(splitKey);
        window.location.href = urlSplit[0] + window.location.host + '/#/' + urlSplit[1].replace('#/', '');
    }

	onMount(() => {
		sessionId = getCookie('aumee-session-id');

		if(sessionId) {
			const options = { headers: {"Session-Id": sessionId}};
			axios.get(addStats('/analytics/visit'), options).then((response) => {
				isLoading = false;
			}, (error) => {
				console.error(error);
				deleteCookie('aumee-session-id');
				location.reload();
			});
		} else {
			axios.get(addStats('/analytics/session')).then((response) => {
				const session = response.data;
				setCookie('aumee-session-id', session.sessionId);
				sessionId = session.sessionId;
				isLoading = false;
			});
		}

		AumeeAnalytics.addPopStateCallback('main', () => {
            handleScroll('main');
        });
        handleScroll('main');
		handleSection();
	})

    onDestroy(() => {
        AumeeAnalytics.removePopStateCallback('main');
    })

	function handleSection() {
		const section = extractSectionValue();

		const categoryFound = profile.categories.find(c => c.name === section);
		if(categoryFound) {
			categoryToDisplay = categoryFound;
			isDelayNeeded = false;
		}
	}

	function onDetailsClicked () {
		window.location.href = '/#/';
		categoryToDisplay = null;
		isDelayNeeded = false;
	}

	
</script>

<main id="main">
	{#if !isLoading}
		<div in:fade="{{delay: 600, duration: 500}}" class="part left-part">
			<ProfilePicture profile={profile}/>
			{#if categoryToDisplay}
				<div class="category-detail content-left-container" in:fly={{duration: 600, x: -100}} out:fly={{ duration: 600, x: -300 }}>
					<CategorySummary on:click={onDetailsClicked} category={categoryToDisplay}/>
					<Button on:click={onDetailsClicked}/>
				</div>
			{/if}
		</div>
		<div in:fade="{{delay: 600, duration: 400}}" class="part right-part">
			<div class="first-content content-right-container">
				<CircleSVG delay={600}/>
				<ProfileInformations profile={profile}/>
			</div>
			<div class="second-content content-right-container category-detail">
				<CircleSVG delay={(isDelayNeeded) ? 1800 : 0} translateY=-1/>
				<div class="categories">
					<Categories 
						bind:categorySelected={categoryToDisplay}
						flyIn={{delay: (isDelayNeeded) ? 1800 : 0, duration: 600, y: 200}}
						flyOut={{duration: 600, x: 300}}
						categories={profile.categories}/>
				</div>
				{#if categoryToDisplay}
					<CategoryDetail
						category={categoryToDisplay}/>
				{/if}
			</div>
		</div>
	{:else}
		<div class="loading" transition:fly="{{duration: 600, y: 100}}">
			Loading...
		</div>
	{/if}
</main>

<style>
	main {
		text-align: center;
		margin: 0 auto;
		display: flex;
		flex-wrap: nowrap;
		flex-direction: row;
		justify-content: center;
		min-height: 100%;
	}

	.loading {
		position: absolute;
		top: 40%;
		left: 50%;
		transform: translateX(-50%);
	}

	.part {
		display: flex;
		flex-flow: column nowrap;
		min-height: 100%;
	}

	.left-part {
		width: 30%;
		border-right: 2px solid var(--color-secondary);
		justify-content: start;
		align-items: center;
	}

	.right-part {
		width: 70%;
		border-left: 2px solid var(--color-secondary);	
	}

	.first-content {
		margin-top: 10%;
	}

	.second-content {
		margin-top: 6%;
	}

	.content-right-container {
		display: flex;
		flex-direction: row;
		flex-wrap: nowrap;
		justify-content: flex-start;
		align-items: baseline;
	}

	.content-left-container {
		width: 100%;
		padding: 15px 0px 15px 0px;
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		align-items: center;
		background-color: var(--color-grey-light);
		margin-top: 18%;
	}

	.categories {
		position: absolute;
		z-index: 0;
	}

	.category-detail {		
		flex-grow: 1;
	}

	@media only screen and (min-width: 768px) {

		.left-part {
			width: 20%;
		}

		.right-part {
			width: 80%;
		}

		.second-content {
			margin-top: 12.5%;
		}

		.content-left-container {
			margin-top: 0%;
		}
	}

	@media only screen and (min-width: 1850px) {
		.first-content {
			margin-top: 150px;
		}

		.second-content {
			margin-top: 190px;
		}
	}

</style>